module.exports = __webpack_public_path__ + "static/media/Tyrion Lannister 1.a96167f9.jpg";